import { useRef, useSyncExternalStore } from "react";
import { sceneTimeBus } from "../../../common/scene_clock.es6";

// Re-renders only when the box's stage changes, not on every frame.
export default function VisorBoxSlot({ sceneId, stageAt, children }) {
  const last = useRef("off");
  const read = () => {
    if (sceneTimeBus.frameSceneId === sceneId) last.current = stageAt(sceneTimeBus.frame);
    return last.current;
  };
  const stage = useSyncExternalStore(sceneTimeBus.subscribeFrame, read, read);
  if (stage === "off") return null;
  return children(stage === "prewarm");
}
